import { render } from "./productsModal.vue?vue&type=template&id=2bf9bdd2&scoped=true"
import script from "./productsModal.vue?vue&type=script&lang=js"
export * from "./productsModal.vue?vue&type=script&lang=js"

import "./productsModal.vue?vue&type=style&index=0&id=2bf9bdd2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf9bdd2"]])

export default __exports__